"use client"

import { Check } from "lucide-react"
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu"
import { CommunityEntry } from "@types"

interface SegmentsDropdownProps {
  segments: CommunityEntry[]
  onSelect: (segment: CommunityEntry | null) => void
  selectedSegmentId?: string | null
}

export function SegmentsDropdown({
  segments,
  onSelect,
  selectedSegmentId,
}: SegmentsDropdownProps) {
  return (
    <DropdownMenuContent
      className="w-60 rounded-md bg-popover border-border shadow-sm"
      align="start"
    >
      <div className="px-1">
        <DropdownMenuItem
          className="flex justify-between items-center px-2 py-1.5 rounded-sm cursor-pointer"
          onClick={() => onSelect(null)}
        >
          <span className="text-sm text-foreground font-normal">
            Publication
          </span>
          {!selectedSegmentId && (
            <Check className="h-4 w-4 text-muted-foreground" />
          )}
        </DropdownMenuItem>
      </div>

      {segments.length > 0 && (
        <>
          <DropdownMenuSeparator />

          <div className="px-1">
            <DropdownMenuLabel className="px-2 py-1.5 text-sm font-semibold text-foreground">
              Segments
            </DropdownMenuLabel>
          </div>

          <div className="px-1 max-h-[200px] overflow-y-auto">
            {segments.map((community) => (
              <DropdownMenuItem
                key={community.id}
                className="flex justify-between items-center px-2 py-1.5 rounded-sm cursor-pointer"
                onClick={() => onSelect(community)}
              >
                <span className="text-sm text-foreground font-normal">
                  {community.name}
                </span>
                {selectedSegmentId === community.id && (
                  <Check className="h-4 w-4 text-muted-foreground" />
                )}
              </DropdownMenuItem>
            ))}
          </div>
        </>
      )}
    </DropdownMenuContent>
  )
}
